import { api } from '../../api/fetch';

export const fetchUserOrganisations = async () => {
  return await api.get('/api/v1/organisations');
};

export default fetchUserOrganisations;
